(function(){
	var runFlag = true;
	if("tlabRecItemId" in window){
		myTlabRecItemId = formatItemId(tlabRecItemId);
	}else{
		runFlag = false;
	}

	var tlabRecCatId = '2';
	var recommendDivIdName = 'tlab_recommend_same';
	var designType = 'detail-2023';

	if(runFlag){
		document.write(
			'<div id="' + recommendDivIdName + '" ></div>'
		);

		var Recommend_obj = new TLAB.Recommend(recommendDivIdName, myTlabRecItemId, tlabRecCatId, designType);
		Recommend_obj.sendRequest();
		delete Recommend_obj;
	}

	function formatItemId(argId){
		return argId;
	}
})();
